// Этот файл генерируется автоматически, его не следует редактировать вручную
import collapse from '@/widgets/collapse.js';
import headerSticky from '@/widgets/headerSticky.js';
import mobileMenu from '@/widgets/mobileMenu.js';
import mobileMenuButton from '@/widgets/mobileMenuButton.js';
import createVueWidget from '@/core/createVueWidget.js';
import painScale from '@/widgets/painScale.vue';
import scrollTop from '@/widgets/scrollTop.js';
import sliderMain from '@/widgets/sliderMain.js';
import sliderPeculiarities from '@/widgets/sliderPeculiarities.js';
import videoBlock from '@/widgets/videoBlock.js';

export default {
  'collapse': async () => { return { default: collapse }; },
  'headerSticky': async () => { return { default: headerSticky }; },
  'mobileMenu': async () => { return { default: mobileMenu }; },
  'mobileMenuButton': async () => { return { default: mobileMenuButton }; },
  'painScale': async () => { return { default: (element, data) => createVueWidget(painScale, element, data) }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'sliderMain': async () => { return { default: sliderMain }; },
  'sliderPeculiarities': async () => { return { default: sliderPeculiarities }; },
  'videoBlock': async () => { return { default: videoBlock }; }
};
